module.exports = __webpack_public_path__ + "img/knu2_main2.cfa8a2a1.jpg";